<template>
  <div>
    <slot v-bind:company="company"> </slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: {
        name: '(주)펀다',
        lendingRegisterNumber: '온라인투자연계금융업<br />2022-금융위원회-18',
        phoneNumber: '02-6925-1788',
        businessNumber: '724-87-00107',
        address: '서울 서초구 사평대로53길 30 메이크잇 203호 ,204호',
      },
    }
  },
}
</script>
